module.exports = __webpack_public_path__ + "img/logo_anafra.32d523c9.png";